var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inspectionAccountExpand"},[_c('data-list',{attrs:{"data":_vm.scope.row.children,"columns":_vm.columns,"isShowHeader":false,"table-style":{ name: 'mixture' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }